// Shared app assets
export const OFFROAD_ICON_URL = "https://static.prod-images.emergentagent.com/jobs/60aaf568-1e1a-4527-97bf-fc896d1bd3d2/images/04537aaf8f60abd171c931c58da5cd76c22af29f5769fcb343613da7c61527e0.png";

export const AppIcon = ({ className = "w-full h-full" }) => (
  <img 
    src={OFFROAD_ICON_URL} 
    alt="Dynamite Off-Road" 
    className={`object-contain ${className}`}
  />
);

export const HeaderIcon = () => (
  <div className="w-8 h-8 bg-amber-500/10 rounded-lg flex items-center justify-center border border-amber-500/30 p-1">
    <AppIcon />
  </div>
);
